//LIBARIES
import React, { Component } from 'react';
import store from 'store';
import styled from 'styled-components';
import FormControl from '@material-ui/core/FormControl';
import FormHelperText from '@material-ui/core/FormHelperText';
import InputLabel from '@material-ui/core/InputLabel';
import PhoneInput from 'react-phone-input-2';
import get from 'lodash/get';

//HELPERS
import { colors } from 'helpers/ColorHelper';

//STYLING
import 'react-phone-input-2/lib/material.css';

const ReactPhoneInputWrapper = styled.div`
  .react-tel-input .form-control + div:before {
    display: none;
  }

  .react-tel-input .country-list {
    width: 200px;
  }

  .form-control.open:hover,
  .selected-flag.open:hover {
    background-color: unset !important;
  }

  .flag-dropdown.open :hover {
    background-color: white !important;
  }

  .selected-flag.open:hover {
    background-color: unset !important;
  }

  .flag-dropdown.open li :hover {
    background-color: unset !important;
  }

  .country-name:hover,
  .dial-code:hover {
    background-color: unset !important;
  }

  .flag-dropdown.open li {
    text-align: left;
    font-size: 14px;
    font-family: 'Circular';
  }

  .flag-dropdown.open li.active,
  .flag-dropdown.open li:hover {
    background-color: #f1f1f1 !important;
  }

  .form-control.open,
  .selected-flag.open,
  .flag-dropdown.open {
    background-color: unset !important;
  }
`;

const StyledLabel = styled(InputLabel)`
  position: absolute;
  top: -30px;
  z-index: 10;
  background: white;
  padding: 0px 5px;
  left: 8px;
  font-size: 10px;
`;

class ReactPhoneInput extends Component {
  handleChange = (value) => {
    if (value === '') {
      this.props.input.onChange('');
    } else {
      this.props.input.onChange('+' + value);
    }
  };

  handleKeyDown = ({ keyCode }) => {
    if (keyCode === 8 && this.props.input.value.length === 2) {
      this.props.input.onChange('');
    }
  };

  render() {
    const countryCodes = store.getState().userTypes.countryCodes;

    const {
      input: { value },
      meta: { touched, error },
      ...props
    } = this.props;

    const showError = touched;

    const inputStyle = {
      color: colors.FONT_GRAY,
      fontWeight: '300',
      fontFamily: 'Circular',
      fontSize: '14px',
      width: '100%',
      padding: '26px 10px 26px 55px',
      borderRadius: '8px',
      boxShadow: 'none',
    };
    if (showError && error) {
      inputStyle.borderColor = colors.RED;
    }

    return (
      <ReactPhoneInputWrapper>
        <FormControl style={get(props, 'style', {})}>
          <StyledLabel>{props.label}</StyledLabel>
          <PhoneInput
            country={countryCodes.phone_default_country_code}
            onlyCountries={countryCodes.phone_only_country_codes || []}
            excludeCountries={countryCodes.phone_exclude_country_codes || []}
            preferredCountries={countryCodes.phone_preferred_country_codes || []}
            value={value}
            onChange={this.handleChange}
            inputProps={{ style: inputStyle }}
            onKeyDown={this.handleKeyDown}
          />
          {showError && error && (
            <FormHelperText
              style={{ color: colors.RED, position: 'relative', left: '10px', top: '5px' }}
            >
              {error}
            </FormHelperText>
          )}
        </FormControl>
      </ReactPhoneInputWrapper>
    );
  }
}

export default ReactPhoneInput;
